module.exports = __webpack_public_path__ + "media/applications/components/ItemApp/assets/images/arrow-down-ace954b3d31943afe84392e7ad3ae3a1.svg";